import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-235f9646"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "overflow-auto pb-5" }
const _hoisted_2 = { class: "svg-icon svg-icon-2tx svg-icon-success me-4" }
const _hoisted_3 = { class: "d-flex flex-stack flex-grow-1 flex-wrap flex-md-nowrap" }
const _hoisted_4 = { class: "mb-3 mb-md-0 fw-bold" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", { class: "text-gray-800 fw-bolder" }, " You have an active subscription! ", -1))
const _hoisted_6 = {
  key: 0,
  class: "fs-6 text-gray-600 pe-7"
}
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "separator separator-dashed my-6" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_Switch = _resolveComponent("Switch")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass(["notice d-flex rounded border border-dashed min-w-lg-600px flex-shrink-0 p-6", [
        _ctx.customClass,
        _ctx.active
          ? 'bg-light-success border-success'
          : 'bg-light-primary border-primary',
      ]])
    }, [
      _createElementVNode("span", _hoisted_2, [
        _createVNode(_component_inline_svg, { src: "media/icons/duotune/coding/cod004.svg" })
      ]),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _hoisted_5,
          (_ctx.note)
            ? (_openBlock(), _createElementBlock("div", _hoisted_6, _toDisplayString(_ctx.note), 1))
            : _createCommentVNode("", true)
        ]),
        _createVNode(_component_Switch, {
          label: "Use Subscription",
          onChange: _ctx.selectSubscription
        }, null, 8, ["onChange"])
      ])
    ], 2),
    _hoisted_7
  ]))
}